export const MAX_IMAGE_FILE_SIZE_BYTES = 2 * 1024 * 1024;

export function validateImageFile(file: File): string | null {
  if (!file.type.startsWith("image/")) {
    return "Можно загрузить только изображение";
  }

  if (file.size > MAX_IMAGE_FILE_SIZE_BYTES) {
    return "Файл слишком большой. Максимум 2MB";
  }

  return null;
}

export function readFileAsDataUrl(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      if (typeof reader.result === "string") {
        resolve(reader.result);
        return;
      }
      reject(new Error("Некорректный формат файла"));
    };
    reader.onerror = () => reject(new Error("Не удалось прочитать файл"));
    reader.readAsDataURL(file);
  });
}
